export const DEFAULT_VIEW_TYPE = 'TILE'
export const VIEW_TYPE_TILE = 'TILE'
export const VIEW_TYPE_LIST = 'LIST'

//temp hardcode for username prefix checking
export const USERNAME_PREFIX = {
  TEMP: "t_",
  TERM: "x_"
}
export const VIEW_IDS = {
  DETAIL_VIEW_ID : 'app-detail',
  ALL_VIEW_ID : 'all',
  DOWNLOAD_VIEW_ID : 'downloads',
  SEARCH_VIEW_ID : 'search'
}

export const ROOT_LINK_TYPES = {
  LINK : 'link',
  DIRECT_DOWNLOAD : 'direct_download',
  AZURE_ACCESS_LINK : 'azure_access_link'
}

export const AZURE_GRAPH_URI = "https://graph.microsoft.com"
export const AZURE_ACCESS_PACK_REQUEST = "/beta/identityGovernance/entitlementManagement/accessPackageAssignmentRequests"
export const AZURE_ACCESS_PACK_MANAGE_LINK = "Request history can be viewed <a target='_blank' href='https://myaccess.microsoft.com/@autodesk.onmicrosoft.com#/request-history'>here</a>."
export const AZURE_ACCESS_PACK_ACTIVE_LINK = "Current access can be viewed <a target='_blank' href='https://myaccess.microsoft.com/@autodesk.onmicrosoft.com#/access-packages/active'>here</a>."

export const DOWNLOADS_MAIL_TO = "mailto:help.hub.download@autodesk.com?subject=Application Access Dashboard - Downloads"

export const INCONTACT_CHAT_LINK="https://home-c6.incontact.com/inContact/ChatClient/ChatClientPatron.aspx?poc=4f93fa0f-21e1-46ce-a233-3d03ea0bfd69&bu=4593230"

export const ERROR_MSGS = {
  GENERIC_ERROR: 'There was an error that wasn’t your fault. Try again later or contact the<HELPDESK_CHAT_LINK/>.',
  FAVORITES_ERROR: 'There was an error modifying favorites. Please try again later.',
  DOWNLOAD_ERROR: 'The download for this application is unavailable. Please contact the<HELPDESK_CHAT_LINK/>for further assistance.',
  APP_NOT_FOUND_WARN: 'Application was not found. Try searching for it by name. If you are still unable to locate it, please contact the<HELPDESK_CHAT_LINK/>.',
}

// Alert types
export const ALERT_CONTEXT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info',
  LIGHT: 'light',
  DARK: 'dark'
}

// Routes (views) that support view select feature (table/tile view)
export const VIEW_SELECT_SUPPORT_ROUTES = [
  'viewContainer',
  'searchView',
  'myFavorites'
]

export const WSS_RESPONSE = {
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  FAILED_PARTIALLY: 'FAILED_PARTIALLY'
}

export const ADSK_DOMAIN = 'autodesk.com'
export const TRANSACTION_TYPE = 'NFR-INTERNAL'
export const WSS_ACTION = 'sendmessage'
export const REDIRECT_DELAY = 10
export const EASIER_STAKEHOLDER_ROLE = 'EASIER_3_STAKEHOLDER'
export const BASE_APS_OPTIONS = {
  client_id: process.env.VUE_APP_APS_CLIENT_ID,
  redirect_uri: process.env.VUE_APP_APS_REDIRECT,
  env: process.env.VUE_APP_APS_ENV,
}